import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class LicenseForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      name: [ '', Validators.required ],
      features: [ '', Validators.required ],
      orderNumber: [ 0, Validators.required ],
      forTrial: [ 0 ]
    });
  }
}
